import React, { createContext, useState, useContext } from 'react';

// Create the File Context
const FileContext = createContext();

// Create a provider component
export const FileProvider = ({ children }) => {
    const [files, setFiles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formType, setFormType] = useState('');


    const addFiles = (newFiles) => {
        setFiles(prevFiles => [...prevFiles, ...newFiles]);
    };

    const removeFile = (index) => {
        setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    return (
        <FileContext.Provider value={{ files, addFiles, removeFile, showModal, setShowModal, formType, setFormType }}>
            {children}
        </FileContext.Provider>
    );
};

// Custom hook for using file context
export const useFileContext = () => useContext(FileContext);
